import React, { useEffect } from 'react';

import { useMst } from '../../mobx-models/Root';

export const VALID_ROUTES_FOR_RELOAD = [
  '/work-packages',
  '/inspection-list',
  '/inspection-details',
  '/deficiencies',
  '/checklist',
  '/PMChecklist',
  '/complete-inspection',
];

const ReloadHandler = () => {
  const { appVersion } = useMst();

  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    if (VALID_ROUTES_FOR_RELOAD.includes(window.location.pathname) && !appVersion.hasNewUpdate) {
      event.preventDefault();
      return '';
    }
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return <></>;
};

export default ReloadHandler;
